<template>
    <v-card flat style="border-top: 1px solid lightgray">
        <v-overlay :value="loadingUnmatchedShopsList">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        <v-data-table
            :items-per-page="500"
            :footer-props="footerProps"
            class="product-table"
            dense
            :headers="tableHeaders"
            :items="unmatchedShops"
        >
            <template v-slot:item="{ item }">
                <tr
                    :key="'unmatched_shop_' + item.id"
                    @click="handleTableRowClick(item)"
                    :class="{
                        activeTableRow: activeUnmatchedShop && parseInt(item.id) === parseInt(activeUnmatchedShop.id)
                    }"
                >
                    <td>{{ item.code ? item.code : "-" }}</td>
                    <td style="text-align: left;">{{ item.name ? item.name : "-" }}</td>
                    <td style="text-align: left;">
                        {{
                            item.type
                                ? (item.type.charAt(0).toUpperCase() + item.type.slice(1)).replaceAll("_", " ")
                                : "-"
                        }}
                    </td>
                    <td style="text-align: end;">{{ item.date ? item.date : "-" }}</td>
                </tr>
            </template>
        </v-data-table>
    </v-card>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import Store from "../../store";
import { PermissionsConstants } from "@/permissions";

export default {
    name: "unmatched-shops-list",
    components: {},
    data() {
        return {
            search: null,
            footerProps: { "items-per-page-options": [25, 50, 100, 500] },
            tableHeaders: [
                {
                    text: this.t("Code"),
                    align: "left",
                    value: "code"
                },
                {
                    text: this.t("Name"),
                    align: "left",
                    value: "name"
                },
                {
                    text: this.t("Type"),
                    align: "left",
                    value: "type"
                },
                {
                    text: this.t("Date"),
                    align: "end",
                    value: "date"
                }
            ]
        };
    },
    mounted() {
        if (this.drawerOpen) {
            document.documentElement.style.overflow = "hidden";
        }
        Store.dispatch("UnmatchedShopsStore/getUnmatchedShopsList");
    },
    watch: {
        options(val) {
            Store.commit("ExportSaleInvoiceStore/setTableOptions", val);
        },
        drawerOpen() {
            if (this.drawerOpen) {
                document.documentElement.style.overflow = "hidden";
            } else {
                document.documentElement.style.overflow = "auto";
            }
        }
    },
    computed: {
        ...mapState("UnmatchedShopsStore", [
            "unmatchedShops",
            "loadingUnmatchedShopsList",
            "activeUnmatchedShop",
            "drawerOpen",
            "shops"
        ]),
        ...mapGetters(["hasPermissionForAction"]),
        PermissionsConstants() {
            return PermissionsConstants;
        }
    },
    methods: {
        handleTableRowClick(invoice) {
            if (!this.hasPermissionForAction(PermissionsConstants.UNMATCHED_SHOP, PermissionsConstants.VIEW)) {
                return;
            }
            Store.commit("UnmatchedShopsStore/resetNewShopData");
            if (this.$route.name !== "unmatched-shops-view") {
                this.$router.push({
                    name: "unmatched-shops-view",
                    params: { invoiceId: invoice.id, invoiceType: invoice.type }
                });
                return;
            }
            if (
                this.$route.name === "unmatched-shops-view" &&
                parseInt(invoice.id) !== parseInt(this.$route.params.invoiceId)
            ) {
                // TODO :: There can be an error with typ
                this.$router.push({
                    name: "unmatched-shops-view",
                    params: { invoiceId: invoice.id, invoiceType: invoice.type }
                });
                Store.dispatch("UnmatchedShopsStore/getUnmatchedShopsData", {
                    invoiceId: invoice.id,
                    invoiceType: invoice.type
                });
            }
        }
    }
};
</script>

<style scoped>
.activeTableRow {
    background-color: #f41823;
    color: #fff;
}

.activeTableRow:hover {
    background-color: #e11520 !important;
    color: #fff !important;
}

.dot {
    margin-top: 4px;
    height: 15px;
    width: 15px;
    border-radius: 50%;
    display: inline-block;
}

.v-data-table-header {
    background-color: #f0f0f0;
}

.preventscroll {
    overflow-y: scroll;
    width: 100%;
}

td {
    padding: 0px;
}

.v-row-group__summary {
    background-color: #b1b1b1 !important;
    height: 40px;
}
::v-deep .v-data-table-header th {
    white-space: nowrap;
}
td {
    height: 25px !important;
}
</style>
